// see https://kazupon.github.io/vue-i18n/started.html

export default {
  fr: {
    header: {
      title: 'Programme Loyauté',
      accounts_users: 'Comptes utilisateurs',
      accounts_admins: 'Comptes administrateurs',
      files_mine: 'Mes fichiers',
      files_shared: 'Partagés avec moi',
      my_profile: 'Mon profil',
      title_profile: 'Profil',
      title_edit: 'Modification',
      title_create: 'Création',
      logout: 'Me déconnecter'
    },
    404: {
      title: '404 - page non-trouvée',
      desc: 'Oups, il semble que cette page n’existe pas...',
      action: 'Retourner à la page d’accueil'
    },
    roles: {
      CLIENT: 'Client',
      ADMIN: 'Administrateur',
      SUPER_ADMIN: 'Super administrateur'
    },
    titles: {
      login: 'Connectez-vous à votre compte',
      logout: 'Vous êtes déjà connecté, voulez-vous vous déconnecter ?',
      forgot_password: 'Mot de passe oublié?',
      reset_password: 'Veuillez rentrer un nouveau mot de passe'
    },
    files: {
      name: 'Nom',
      date: 'Date',
      date_shared: 'Partagé le',
      my_files_title: 'Mes fichiers',
      shared_files_title: 'Partagés avec moi',
      my_files_add: 'Ajouter un fichier',
      upload: 'Glissez vos fichiers ici pour téléverser ou <span>sélectionnez votre fichier</span> (200MB max)',
      uploading: 'Téléversement en cours...',
      delete_modal_title: 'Supprimer le fichier ?',
      delete_modal_content: 'Voulez-vous vraiment supprimer le fichier <strong>{name}</strong> ?',
      rename_modal_title: 'Renommer le fichier ?',
      rename_modal_content: 'Nouveau nom'
    },
    user: {
      last_name: 'Nom',
      first_name: 'Prénom',
      company: 'Compagnie',
      folder: 'Répertoire',
      role: 'Rôle',
      responsible: 'Responsable',
      email: 'Courriel',
      language: 'Langue de préférence',
      password_old: 'Ancien mot de passe',
      password_new: 'Nouveau mot de passe',
      password_new_confirm: 'Confirmer le nouveau mot de passe',
      password: 'Mot de passe',
      admin_add: 'Ajouter un administrateur',
      admin_list_title: 'Comptes administrateurs',
      admin_delete_modal_title: 'Supprimer l\'administrateur',
      admin_delete_modal_content: 'Voulez-vous vraiment supprimer l\'administrateur <strong>{name}</strong> ?',
      admin_delete_modal_replacement: 'Veuillez choisir un remplaçant:',
      client_add: 'Ajouter un utilisateur',
      client_list_title: 'Comptes utilisateurs',
      client_delete_modal_title: 'Supprimer l\'utilisateur',
      client_delete_modal_content: 'Voulez-vous vraiment supprimer l\'utilisateur <strong>{name}</strong> ?',
      client_files: 'Fichiers du client',
      client_files_shared: 'Fichiers pour le client',
      client_files_add: 'Ajouter un fichier'
    },
    actions: {
      manage_client: 'Gérer',
      manage_admin: 'Gérer',
      edit_client: 'Modifier le profil',
      edit_admin: 'Modifier le profil',
      edit_profile: 'Modifier mon profil',
      rename: 'Renommer',
      save: 'Enregistrer les modifications',
      cancel: 'Annuler',
      delete: 'Supprimer',
      download: 'Télécharger',
      login: 'Me connecter',
      go_back: 'Retourner',
      send_mail: 'Envoyer courriel',
      reset_password: "Réinitialiser votre mot de passe"
    },
    alerts: {
      delete_success: 'L\'utilisateur {name} a été supprimé',
      delete_error: 'L\'utilisateur {name} n\'a pas pu être supprimé',
      create_success: 'L\'utilisateur {name} a été créé',
      create_error: 'L\'utilisateur {name} n\'a pas pu être créé',
      update_success: 'L\'utilisateur {name} a été modifié',
      update_error: 'L\'utilisateur {name} n\'a pas pu être modifié',
      profile_update_success: 'Le profil a été modifié',
      profile_update_error: 'Le profil n\'a pas pu être modifié',
      login_error: 'Le courriel ou mot de passe est invalide',
      request_password_success: 'Si votre compte existe, un courriel sera envoyé à {name} pour réinitialiser votre mot de passe',
      reset_password_success: "Mot de passe réinitialisé!",
      reset_password_error: "Le mot de passe n'a pas pu être réinitialisé!",
      server_error: "Une erreur est survenu avec le serveur",
      delete_file_success: 'Le fichier {name} a été supprimé',
      delete_file_error: 'Le fichier {name} n\'a pas pu être supprimé',
      upload_file_success: '{count} fichiers ont été téléversés',
      upload_file_error: '{count} fichiers n\'ont pas été téléversés',
      rename_file_success: 'Le fichier {oldName} a été renommé en {newName}',
      rename_file_error: 'Le fichier {oldName} n\'a pas pu être renommé',
      download_file_error: 'Le fichier {name} n\'a pas pu être téléchargé'
    },
    http: {
      400: 'La syntaxe de la requête est erronée',
      401: 'Une authentification est nécessaire pour accéder à la ressource',
      403: 'Votre session est expirée',
      404: 'Ressource non trouvée',
      409: 'Un conflit est survenu',
      500: 'Erreur interne du serveur'
    },
    languages: {
      fr: 'Français',
      en: 'Anglais'
    },
    messages: {
      required: (field, val) => "Le champ est requis",
      email: (field, val) => "Courriel non valide",
      password: (field, val) => "Mot de passe non valide",
      filename: "Le nom du fichier ne peut être vide",
      file_size_limit: "Un fichier ne peut dépasser 200MB",
      pwd_confirm: "Le mot de passe doit être le même",
      pwd_required: "Le mot de passe est requis",
      generic: "Désolé, une erreur est survenue"
    }
  },
  en: {
    header: {
      title: 'Fidelity program',
      accounts_users: 'Users accounts',
      accounts_admins: 'Admins accounts',
      files_mine: 'My files',
      files_shared: 'Shared with me',
      my_profile: 'My profile',
      title_profile: 'Profile',
      title_edit: 'Edit',
      title_create: 'Create',
      logout: 'Logout'
    },
    404: {
      title: '404 - page not found',
      desc: 'Oops, it seems this page does not exist...',
      action: 'Go back to home page'
    },
    titles: {
      login: 'Login to your account',
      logout: 'You are already logged, do you want to logout ?',
      forgot_password: 'Forgot your password?',
      reset_password: 'Please enter your new password'
    },
    files: {
      name: 'Name',
      date: 'Date',
      date_shared: 'Shared on',
      my_files_title: 'My files',
      shared_files_title: 'Shared with me',
      my_files_add: 'Add a file',
      upload: 'Drag and drop your files here or <span>select folder</span> (200MB max)',
      uploading: 'Uploading files...',
      delete_modal_title: 'Delete file ?',
      delete_modal_content: 'Do you really want to delete file <strong>{name}</strong> ?',
      rename_modal_title: 'Rename file ?',
      rename_modal_content: 'New name'
    },
    roles: {
      CLIENT: 'Client',
      ADMIN: 'Administrator',
      SUPER_ADMIN: 'Super administrator'
    },
    user: {
      last_name: 'Last name',
      first_name: 'First name',
      company: 'Company',
      email: 'Email',
      folder: 'Folder',
      responsible: 'Responsible',
      role: 'Role',
      language: 'Preferred language',
      password_old: 'Old password',
      password_new: 'New password',
      password_new_confirm: 'New password confirmation',
      password: 'Password',
      admin_add: 'Add an admin',
      admin_list_title: 'Admins accounts',
      admin_delete_modal_title: 'Delete admin',
      admin_delete_modal_content: 'Do you really want to delete admin <strong>{name}</strong> ?',
      admin_delete_modal_replacement: 'Please select a replacement:',
      client_add: 'Add an user',
      client_list_title: 'Users accounts',
      client_delete_modal_title: 'Delete user',
      client_delete_modal_content: 'Do you really want to delete user <strong>{name}</strong> ?',
      client_files: 'Files uploaded by the client',
      client_files_shared: 'Files shared with client',
      client_files_add: 'Add a file'
    },
    actions: {
      manage_client: 'Manage user',
      manage_admin: 'Manage admin',
      edit_client: 'Update profile',
      edit_admin: 'Update profile',
      edit_profile: 'Edit my profile',
      rename: 'Rename',
      save: 'Save modifications',
      cancel: 'Cancel',
      delete: 'Delete',
      download: 'Download',
      login: 'Login',
      go_back: 'Go back',
      send_mail: 'Send reset link',
      reset_password: "Reset Password"
    },
    alerts: {
      delete_success: 'User {name} has been deleted',
      delete_error: 'User {name} has not been deleted',
      create_success: 'User {name} has been created',
      create_error: 'User {name} has not been created',
      update_success: 'User {name} has been updated',
      update_error: 'User {name} has not been updated',
      profile_update_success: 'Your profile has been updated',
      profile_update_error: 'Your profile has not been updated',
      login_error: 'Wrong email or password',
      request_password_success: 'If your account exists, an email will be sent to {name} in order to reset your password',
      reset_password_success: "Password successfully changed!",
      reset_password_error: "Password could not be changed",
      server_error: "An error occured with the server",
      delete_file_success: 'File {name} has been deleted',
      delete_file_error: 'File {name} has not been deleted',
      upload_file_success: '{count} files have been uploaded',
      upload_file_error: '{count} files have not been uploaded',
      rename_file_success: 'File {oldName} has been renamed to {newName}',
      rename_file_error: 'Failed to rename file {oldName}',
      download_file_error: 'Failed to download file {name}'
    },
    http: {
      400: 'Bad Request',
      401: 'Unauthorized access',
      403: 'Your session has expired',
      404: 'Resource not found',
      409: 'A conflict occurred',
      500: 'Internal server error'
    },
    languages: {
      fr: 'French',
      en: 'English'
    },
    messages: {
      required: (field, val) => "Field is required",
      email: (field, val) => "Invalid email",
      password: (field, val) => "Invalid password",
      filename: "Filename can't be empty",
      file_size_limit: "File size is limited to 200MB",
      pwd_confirm: "Password don't match",
      pwd_required: "Password is required",
      generic: "Sorry an unexpected error happened"
    }
  }
}





// WEBPACK FOOTER //
// ./src/messages.js